(function () {
  function initReviewPagination() {
    var reviewList = document.querySelector(".product-review-list");
    if (!reviewList || reviewList.getAttribute("data-review-pagination-ready") === "true") return;

    var reviewSection = reviewList.closest(".product-reviews-section");
    var reviews = Array.prototype.slice.call(reviewList.querySelectorAll("[data-review-page]"));
    var buttons = reviewSection
      ? Array.prototype.slice.call(reviewSection.querySelectorAll("[data-review-page-button]"))
      : [];
    if (!reviews.length || !buttons.length) return;

    reviewList.setAttribute("data-review-pagination-ready", "true");

    function showPage(page, shouldScroll) {
      reviews.forEach(function (review) {
        review.hidden = Number(review.getAttribute("data-review-page")) !== page;
      });
      buttons.forEach(function (button) {
        var isCurrent = Number(button.getAttribute("data-review-page-button")) === page;
        button.classList.toggle("is-active", isCurrent);
        if (isCurrent) button.setAttribute("aria-current", "page");
        else button.removeAttribute("aria-current");
      });
      if (shouldScroll) {
        var top = reviewList.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        showPage(Number(button.getAttribute("data-review-page-button")), true);
      });
    });
    showPage(1, false);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReviewPagination);
  } else {
    initReviewPagination();
  }
})();
